import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';

const PH = 'https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=200&q=60';
const resolveImg = ph => !ph ? PH : ph.startsWith('http') ? ph : `https://shop.venkatagirihandlooms.com/${ph.replace(/^\/+/,'')}`;

export default function CartPage() {
  const { cart, updateQty, removeItem, loading } = useCart();
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!user) return (
    <div className="page" style={{textAlign:'center',paddingTop:140}}>
      <div style={{fontSize:56}}>🛒</div>
      <h2 style={{fontFamily:"'Playfair Display',serif",fontSize:26,color:'#7a1f1f',fontStyle:'italic',marginTop:12,marginBottom:8}}>Your Cart</h2>
      <p style={{color:'#8a7968',marginBottom:20,fontSize:14}}>Please login to view your cart</p>
      <Link to="/login" className="btn btn-primary">Login</Link>
    </div>
  );
  if (loading) return <div className="page"><div className="spinner"/></div>;
  if (!cart.items.length) return (
    <div className="page" style={{textAlign:'center',paddingTop:140}}>
      <div style={{fontSize:56}}>🧵</div>
      <h2 style={{fontFamily:"'Playfair Display',serif",fontSize:26,color:'#7a1f1f',fontStyle:'italic',marginTop:12,marginBottom:8}}>Cart is empty</h2>
      <p style={{color:'#8a7968',marginBottom:20,fontSize:14}}>Discover our beautiful handloom collections</p>
      <Link to="/collections" className="btn btn-primary">Explore Collections</Link>
    </div>
  );

  const shipping = cart.total >= 999 ? 0 : 99;
  const grandTotal = cart.total + shipping;

  return (
    <div className="page">
      <div className="container" style={{padding:'40px 24px 64px'}}>
        <h1 style={{fontFamily:"'Playfair Display',serif",fontSize:'clamp(1.6rem,3vw,2.4rem)',color:'#7a1f1f',fontStyle:'italic',marginBottom:32}}>Shopping Cart <span style={{fontSize:16,color:'#8a7968',fontStyle:'normal',fontFamily:"'Jost',sans-serif"}}>({cart.count} items)</span></h1>
        <div className="cart-main-layout" style={{display:'grid',gridTemplateColumns:'1fr 320px',gap:40,alignItems:'start'}}>
          {/* Items */}
          <div>
            <div className="hidden-mobile" style={{display:'flex',gap:20,padding:'0 0 14px',borderBottom:'2px solid var(--border)',marginBottom:8,fontSize:10,letterSpacing:2,textTransform:'uppercase',color:'#8a7968'}}>
              <span style={{flex:3}}>Product</span>
              <span style={{width:120,textAlign:'center'}}>Quantity</span>
              <span style={{width:100,textAlign:'right'}}>Total</span>
            </div>
            {cart.items.map(item => {
              const ip = item.selling_price * (1 - (item.discount_pct||0)/100);
              return (
                <div key={item.id} style={{display:'flex',alignItems:'center',gap:16,padding:'20px 0',borderBottom:'1px solid #f0e8e0',flexWrap:'wrap'}}>
                  <div style={{flex:3,display:'flex',gap:16,alignItems:'flex-start',cursor:'pointer',minWidth:200}} onClick={()=>navigate(`/product/${item.slug}`)}>
                    <img src={resolveImg(item.photo)} alt={item.name} style={{width:76,height:96,objectFit:'cover',background:'#f7f0e6',flexShrink:0}} onError={e=>{e.target.src=PH;}}/>
                    <div>
                      <div style={{fontFamily:"'Cormorant Garamond',serif",fontSize:18,color:'#1a0f0f',lineHeight:1.3,marginBottom:4}}>{item.name}</div>
                      {item.material && <div style={{fontSize:11,color:'#8a7968',marginBottom:2}}>{item.material}</div>}
                      {item.color_shade && <div style={{fontSize:11,color:'#8a7968',marginBottom:2}}>{item.color_shade}</div>}
                      <div style={{fontFamily:"'Cormorant Garamond',serif",fontSize:17,color:'#7a1f1f',fontWeight:600,marginTop:6}}>₹{ip.toLocaleString('en-IN',{maximumFractionDigits:0})}</div>
                      <button onClick={e=>{e.stopPropagation();removeItem(item.id);}} style={{marginTop:8,fontSize:11,color:'#c00',background:'none',border:'none',cursor:'pointer',padding:0,fontFamily:"'Jost',sans-serif"}}>Remove</button>
                    </div>
                  </div>
                  <div style={{width:116}}>
                    <div style={{display:'flex',alignItems:'center',border:'1.5px solid var(--border)'}}>
                      <button onClick={()=>updateQty(item.id,item.qty-1)} style={{width:32,height:32,background:'#f7f0e6',border:'none',cursor:'pointer',fontSize:16}}>−</button>
                      <span style={{width:36,textAlign:'center',fontFamily:"'Cormorant Garamond',serif",fontSize:17}}>{item.qty}</span>
                      <button onClick={()=>updateQty(item.id,item.qty+1)} style={{width:32,height:32,background:'#f7f0e6',border:'none',cursor:'pointer',fontSize:16}}>+</button>
                    </div>
                  </div>
                  <div style={{width:90,textAlign:'right',fontFamily:"'Cormorant Garamond',serif",fontSize:18,color:'#7a1f1f',fontWeight:600}}>₹{Number(item.subtotal).toLocaleString('en-IN',{maximumFractionDigits:0})}</div>
                </div>
              );
            })}
            <div style={{paddingTop:20}}>
              <Link to="/collections" className="btn btn-outline" style={{fontSize:11}}>← Continue Shopping</Link>
            </div>
          </div>

          {/* Summary */}
          <div style={{background:'#fff',border:'1px solid var(--border)',padding:24,position:'sticky',top:'calc(var(--nav-h)+16px)'}}>
            <h3 style={{fontFamily:"'Playfair Display',serif",fontSize:20,color:'#1a0f0f',fontStyle:'italic',marginBottom:20}}>Order Summary</h3>
            {[['Subtotal',`₹${Number(cart.total).toLocaleString('en-IN',{maximumFractionDigits:0})}`],['Shipping',shipping===0?'Free 🎉':`₹${shipping}`]].map(([k,v])=>(
              <div key={k} style={{display:'flex',justifyContent:'space-between',fontSize:14,color:'#5a3a3a',marginBottom:12,fontFamily:"'Jost',sans-serif"}}><span>{k}</span><span style={k==='Shipping'&&shipping===0?{color:'#2e7d32'}:{}}>{v}</span></div>
            ))}
            {shipping>0 && <div style={{fontSize:11,color:'#e65100',marginBottom:12,fontFamily:"'Jost',sans-serif"}}>Add ₹{(999-cart.total).toFixed(0)} more for free shipping</div>}
            <div style={{display:'flex',justifyContent:'space-between',borderTop:'2px solid var(--border)',paddingTop:14,marginBottom:20,fontFamily:"'Cormorant Garamond',serif",fontSize:22,color:'#7a1f1f',fontWeight:600}}>
              <span>Total</span><span>₹{grandTotal.toLocaleString('en-IN',{maximumFractionDigits:0})}</span>
            </div>
            <button onClick={()=>navigate('/checkout')} className="btn btn-primary" style={{width:'100%',justifyContent:'center',padding:'15px',fontSize:12}}>Checkout →</button>
            <div style={{textAlign:'center',marginTop:14,fontSize:11,color:'#8a7968'}}>🔒 Secure · Cards · UPI · COD</div>
          </div>
        </div>
      </div>
    </div>
  );
}
